import React from 'react';
import type { QueryMode } from '../../types';

export type ProjectContextMode = Extract<
  QueryMode,
  'projects' | 'docking' | 'progress'
>;

export interface ProjectContextLinksProps {
  current: ProjectContextMode;
  dockingCount: number;
  progressCount: number;
  incompleteProgressCount: number;
  onNavigate: (mode: ProjectContextMode) => void;
}

/**
 * 详情面板顶部：在「项目详情 / 对接记录 / 工作进展」之间跳转，并带上当前项目上下文。
 */
export function ProjectContextLinks(
  props: ProjectContextLinksProps,
): React.ReactElement {
  const {
    current,
    dockingCount,
    progressCount,
    incompleteProgressCount,
    onNavigate,
  } = props;

  const items: {
    mode: ProjectContextMode;
    label: string;
  }[] = [
    { mode: 'projects', label: '项目详情' },
    {
      mode: 'docking',
      label: dockingCount > 0 ? `对接记录 (${dockingCount})` : '对接记录',
    },
    {
      mode: 'progress',
      label:
        incompleteProgressCount > 0
          ? `工作进展 (${incompleteProgressCount} 未完成)`
          : progressCount > 0
            ? `工作进展 (${progressCount})`
            : '工作进展',
    },
  ];

  return (
    <nav className="project-context-links" aria-label="关联查看">
      {items.map((item) => {
        const isCurrent = item.mode === current;
        return (
          <button
            key={item.mode}
            type="button"
            className={
              isCurrent
                ? 'project-context-links__btn project-context-links__btn--current'
                : 'project-context-links__btn'
            }
            disabled={isCurrent}
            onClick={() => onNavigate(item.mode)}
          >
            {item.label}
          </button>
        );
      })}
    </nav>
  );
}
